import React from 'react';

const NotFound = () => {
    return (
        <div className="container max-auto text-center mt-12">
            <h2 className="text-gray-800 text-4xl">404</h2>
            <h3 className="text-gray-800 text-xl">Page Not Found</h3>
        </div>
    );
};

export default NotFound;